<h2 mat-dialog-title>Rejection Reason</h2>

<mat-dialog-content [formGroup]="formGroup">
  <lgd-text controlName="reason" label="Reason">
  </lgd-text>

  @if (isSaving) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="end start">
  <button mat-button [mat-dialog-close]="false">Cancel</button>

  <button mat-raised-button color="primary" [disabled]="formGroup.invalid" (click)="save()">Save</button>
</mat-dialog-actions>